export const buttonsData = [
	{
		text: 'Send OTP to your Email',
		className: 'btn-primary',
		sendTo: 'email'
	},
	{
		text: 'Send OTP to your Mobile',
		className: 'btn-yellow my',
		sendTo: 'mobile'
	}
];
